$(function(){
  if($(".time-left-header").length > 0){
    function displayTimerElement(element){const formattedElement = element + '';return formattedElement.length === 1 ? `0${formattedElement}` : formattedElement;}
    function updateTimer(){
      const timerLeft = moment.duration(moment($(".time-left-header").data().timeleft).diff(moment()));
      if(timerLeft._data.minutes <= 0 && timerLeft._data.seconds <= 0){
        window.location.href = "/send/selection"
      } else {
        $("#timeleftHeader").html(`${displayTimerElement(timerLeft._data.minutes)}:${displayTimerElement(timerLeft._data.seconds)}`)
      }
    }

    updateTimer()
    setInterval(() => {
      updateTimer()
    }, 1000)
  }
})